import { render, staticRenderFns } from "./AgendaGroupHeader2.vue?vue&type=template&id=75a4d773&scoped=true"
import script from "./AgendaGroupHeader2.vue?vue&type=script&setup=true&lang=js"
export * from "./AgendaGroupHeader2.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a4d773",
  null
  
)

export default component.exports